// Mock data for Hale Modular website

export const projects = {
  residential: [
    {
      id: 'res-1',
      name: 'The Courtyard Residence',
      location: 'Surat',
      tagline: 'A family home designed around light, air, and three generations',
      category: 'residential',
      area: '4,500 sq.ft.',
      year: '2024',
      architect: 'Studio Axis Design',
      images: [
        'https://images.pexels.com/photos/12594566/pexels-photo-12594566.jpeg',
        'https://images.unsplash.com/photo-1552084850-c6a1fc7cf717',
        'https://images.pexels.com/photos/13608798/pexels-photo-13608798.jpeg',
        'https://images.pexels.com/photos/16800062/pexels-photo-16800062.jpeg',
        'https://images.unsplash.com/photo-1724688078741-6d89e587e809'
      ],
      description: 'Three generations under one roof, yet each with their own sense of privacy and light. The Courtyard Residence is built around a central open space that breathes life into every corner of the home. Stone, brass, and teak create a material palette that will age gracefully over decades. Every joint, every detail calibrated for permanence.'
    },
    {
      id: 'res-2',
      name: 'River View Villa',
      location: 'Vadodara',
      tagline: 'Commanding views meet grounded living',
      category: 'residential',
      area: '6,200 sq.ft.',
      year: '2023',
      architect: 'In-house Design Team',
      images: [
        'https://images.unsplash.com/photo-1724688078741-6d89e587e809',
        'https://images.pexels.com/photos/13608798/pexels-photo-13608798.jpeg',
        'https://images.pexels.com/photos/18273285/pexels-photo-18273285.jpeg',
        'https://images.unsplash.com/photo-1552084850-c6a1fc7cf717',
        'https://images.pexels.com/photos/12594566/pexels-photo-12594566.jpeg'
      ],
      description: 'Perched above the Vishwamitri River, this villa captures panoramic views without surrendering intimacy. Floor-to-ceiling glass on the north facade, grounded by solid masonry on three sides. The structure speaks of restraint - no ornament, only proportion and craft.'
    },
    {
      id: 'res-3',
      name: 'The Terrace House',
      location: 'Ahmedabad',
      tagline: 'Vertical living reimagined for a joint family',
      category: 'residential',
      area: '3,800 sq.ft.',
      year: '2024',
      architect: 'Vir.Mueller Architects',
      images: [
        'https://images.pexels.com/photos/18273285/pexels-photo-18273285.jpeg',
        'https://images.pexels.com/photos/16800062/pexels-photo-16800062.jpeg',
        'https://images.unsplash.com/photo-1622015663319-e97e697503ee',
        'https://images.unsplash.com/photo-1724688078741-6d89e587e809',
        'https://images.pexels.com/photos/13608798/pexels-photo-13608798.jpeg'
      ],
      description: 'A compact urban plot that becomes home to four distinct households across four levels. Each floor operates independently yet shares a common stairwell clad in natural stone. The building steps back at each level, creating generous terraces that bring the outdoors into dense city fabric.'
    }
  ],
  commercial: [
    {
      id: 'com-1',
      name: 'Elevate Office',
      location: 'Ahmedabad',
      tagline: 'A headquarters that reflects ambition',
      category: 'commercial',
      area: '12,000 sq.ft.',
      year: '2023',
      architect: 'In-house Design Team',
      images: [
        'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
        'https://images.unsplash.com/photo-1621831337128-35676ca30868',
        'https://images.pexels.com/photos/16140813/pexels-photo-16140813.jpeg',
        'https://images.pexels.com/photos/13807472/pexels-photo-13807472.jpeg',
        'https://images.unsplash.com/photo-1552084850-c6a1fc7cf717'
      ],
      description: 'A fintech startup first owned headquarters. Open plan without being noisy, collaborative without sacrificing focus. Acoustic ceiling panels, custom millwork, and a palette of warm grays and natural oak. Infrastructure designed for growth - power, data, HVAC all over-engineered for future expansion.'
    },
    {
      id: 'com-2',
      name: 'The Brass Door',
      location: 'Surat',
      tagline: 'A boutique retail space built on material honesty',
      category: 'commercial',
      area: '2,400 sq.ft.',
      year: '2024',
      architect: 'In-house Design Team',
      images: [
        'https://images.pexels.com/photos/16140813/pexels-photo-16140813.jpeg',
        'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
        'https://images.pexels.com/photos/13807472/pexels-photo-13807472.jpeg',
        'https://images.unsplash.com/photo-1621831337128-35676ca30868',
        'https://images.pexels.com/photos/13608798/pexels-photo-13608798.jpeg'
      ],
      description: 'A luxury menswear boutique where the architecture does not compete with the product. Polished concrete floors, blackened steel shelving, and one sculptural brass door that weighs 200 kilograms. Built to welcome customers for the next thirty years.'
    },
    {
      id: 'com-3',
      name: 'Horizon Co-working',
      location: 'Mumbai',
      tagline: 'Flexible workspace infrastructure for a growing enterprise',
      category: 'commercial',
      area: '18,500 sq.ft.',
      year: '2023',
      architect: 'Serie Architects',
      images: [
        'https://images.pexels.com/photos/13807472/pexels-photo-13807472.jpeg',
        'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
        'https://images.unsplash.com/photo-1621831337128-35676ca30868',
        'https://images.pexels.com/photos/16140813/pexels-photo-16140813.jpeg',
        'https://images.unsplash.com/photo-1552084850-c6a1fc7cf717'
      ],
      description: 'Not a trendy co-working space. A serious commercial infrastructure play. Modular partition systems, raised access floors, dedicated server rooms, and backup power. The design allows for full reconfiguration without touching structure or MEP. Built for permanence and adaptability.'
    }
  ]
};

export const blogPosts = [
  {
    id: 'post-1',
    title: 'What to expect when building a custom home in Gujarat',
    date: 'November 2024',
    excerpt: 'The process, timeline, and questions you should be asking before breaking ground.',
    content: 'Building a custom home in Gujarat - whether in Surat, Ahmedabad, or Vadodara - is not simply hiring a contractor and waiting for keys. It is a journey that demands clarity, patience, and the right partner.\n\n**The Reality of Timelines**\n\nA well-executed custom home takes 12 to 18 months from concept to handover. This includes design (2-3 months), approvals (1-2 months), and construction (9-12 months). Anyone promising faster should be questioned. Quality takes time.\n\n**The Questions You Should Ask**\n\nBefore you commit to a design-build firm, ask: Will one person own my project from start to finish? How do you handle changes mid-construction? What happens if materials are delayed? Who will I speak to when something goes wrong? The firms that hesitate are the ones to avoid.\n\n**Why Design and Build Should Never Be Separated**\n\nWhen your architect and builder are not aligned, you become the mediator. Details get lost. Budgets inflate. Timelines slip. A design-build approach eliminates this friction. One team, one vision, one point of accountability.\n\n**The Materials That Matter**\n\nGujarat climate is unforgiving. Cheap waterproofing will fail. Inadequate foundation work will crack. Low-grade flooring will show wear within two years. The materials you choose are not aesthetic decisions - they are structural commitments.\n\nAt Hale Modular, we specify materials that will perform for decades, not seasons. Because a custom home is not a product. It is a legacy.'
  },
  {
    id: 'post-2',
    title: 'Why the best interiors start with architecture, not decoration',
    date: 'October 2024',
    excerpt: 'Interior design without architectural thinking is decoration. Here is the difference.',
    content: 'There is a fundamental misunderstanding in how people approach their homes: they believe interiors are something you add after the building is complete. A coat of paint. Some furniture. Lighting fixtures. This is decoration, not design.\n\n**Architecture Creates the Interior**\n\nThe best interiors are not styled - they are structured. Before a single piece of furniture is selected, the architecture must answer fundamental questions: How does light move through the space across the day? Where do people naturally gather? What is the relationship between private and shared spaces? How do materials age and respond to touch?\n\nThese are not decorative concerns. They are architectural decisions that determine whether a space feels generous or cramped, calm or chaotic.\n\n**Material Decisions Precede Aesthetic Ones**\n\nA beautifully styled room with poor acoustic treatment will always feel uncomfortable. A living room flooded with harsh south-facing sun cannot be saved by curtains alone. An open kitchen without proper ventilation will permeate your home with cooking smells no matter how elegant the cabinetry.\n\nThese issues are resolved at the architectural stage - or not at all.\n\n**The Hale Modular Approach**\n\nWe do not separate architecture and interiors because they are not separate disciplines. From the moment we design a space, we are thinking about millwork, lighting, material transitions, furniture scale, and how the space will be used daily.\n\nBy the time construction is complete, the interior is 80% finished - not because we have installed furniture, but because the architecture has already created the experience. Decoration can enhance a great interior. But it cannot create one.'
  },
  {
    id: 'post-3',
    title: 'For architects: what to look for in a construction partner',
    date: 'September 2024',
    excerpt: 'Your design deserves a builder who respects precision. Here is how to find one.',
    content: 'As an architect, your reputation is only as strong as the builder who executes your vision. A mediocre contractor can destroy months of thoughtful design work with poor craftsmanship, material substitutions, and missed details. Finding the right construction partner is not a procurement exercise. It is a strategic decision.\n\n**The Non-Negotiables**\n\nA serious construction partner should offer:\n\n**1. A Single Point of Accountability**\n\nYou should not be coordinating between the structural engineer, the contractor, the electrician, and the plumber. One project lead should own the entire build.\n\n**2. Transparent Communication**\n\nWeekly progress reports with photos. Immediate notification of issues. No surprises at handover. If a builder is evasive during the bidding process, they will be impossible to work with during construction.\n\n**3. Respect for Your Drawings**\n\nYour construction partner should treat your drawings as sacred documents, not suggestions. Any proposed changes should come with clear reasoning and your explicit approval.\n\n**4. Material and Finish Accountability**\n\nSubstituting specified materials to save costs is not problem-solving - it is sabotage. A trustworthy builder will alert you to supply issues and propose alternatives, not make unilateral decisions.\n\n**The Questions to Ask**\n\nBefore you commit to a builder, ask: Can I visit three of your completed projects and speak to the architects you have worked with? How do you handle design changes mid-construction? What is your policy on material substitutions? Who will be on-site daily managing my project?\n\n**Why Architects Choose Hale Modular**\n\nWe exist because architects were tired of contractors who did not respect their work. Every project is led by a dedicated project manager with an architecture or engineering background. We read drawings the way they are meant to be read. And we build them the way they are meant to be built.\n\nIf you are an architect looking for a construction partner in Gujarat or Mumbai who will honor your vision, let us talk.'
  }
];

export const officeLocations = [
  {
    id: 'mumbai',
    city: 'Mumbai',
    label: 'Hale Modular - Mumbai (Head Office)',
    address: 'Office 301, Horizon Tower, Andheri East, Mumbai 400069, Maharashtra, India',
    phone: '+91 98765 43210',
    email: 'mumbai@halemodular.com',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30167.076424929754!2d72.85716495!3d19.11994395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9d90e089b53%3A0xf0d6c0d6d6e7b4f1!2sAndheri%20East%2C%20Mumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin'
  },
  {
    id: 'gujarat',
    city: 'Gujarat',
    label: 'Hale Modular - Gujarat (Branch Office)',
    address: 'Office 205, Empire Business Hub, Varachha, Surat 395006, Gujarat, India',
    phone: '+91 98765 43211',
    email: 'gujarat@halemodular.com',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59576.99187826405!2d72.8311206!3d21.1911089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f2f6d0e0b0f%3A0x8f6d1c5c4c5c4c5c!2sVarachha%2C%20Surat%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin'
  }
];

export const contactFormOptions = {
  userTypes: ['Homeowner', 'Architect', 'Developer', 'Business Owner', 'Other'],
  cities: ['Surat', 'Ahmedabad', 'Vadodara', 'Rajkot', 'Mumbai', 'Other'],
  projectTypes: ['Residential', 'Commercial', 'Renovation', 'Other'],
  sources: ['Instagram', 'LinkedIn', 'Referral', 'Google Search', 'Other']
};
